import React from 'react';
import { LuBriefcase, LuCheck, LuTreePalm } from 'react-icons/lu';
import { useTranslation } from '../../../i18n/LanguageContext';
import { BAR_TONES, VISIT_STATE_TONES } from '../../ProfilePage/calendar/calendarTones';

const SWATCH = 'tw-grid tw-h-3.5 tw-w-5 tw-shrink-0 tw-place-items-center tw-rounded';

/**
 * Always-visible key under the calendar (the old page's legend): what the
 * colours, the tick and the dashed boxes mean.
 */
const LegendStrip = () => {
  const { t } = useTranslation();
  const label = (key) => t(`profilePage.calendar.legend.${key}`);
  const items = [
    {
      key: 'completedDay',
      swatch: (
        <span className={`${SWATCH} tw-bg-emerald-500 tw-text-white`}>
          <LuCheck className="tw-h-2.5 tw-w-2.5" strokeWidth={3.5} />
        </span>
      ),
    },
    { key: 'windowClosed', swatch: <span className={`${SWATCH} tw-border tw-border-slate-300 dark:tw-border-white/15 ${VISIT_STATE_TONES.windowClosed.chip}`} /> },
    { key: 'inProgress', swatch: <span className={`${SWATCH} ${BAR_TONES.inProgress.mark}`} /> },
    { key: 'overdue', swatch: <span className={`${SWATCH} ${BAR_TONES.overdue.mark}`} /> },
    { key: 'planned', swatch: <span className={`${SWATCH} ${BAR_TONES.planned.mark}`} /> },
    { key: 'screenFail', swatch: <span className={`${SWATCH} ${BAR_TONES.screenFail.mark}`} /> },
    {
      key: 'job',
      swatch: (
        <span className={`${SWATCH} tw-border tw-border-dashed tw-border-slate-400 tw-text-slate-500`}>
          <LuBriefcase className="tw-h-2 tw-w-2" />
        </span>
      ),
    },
    {
      key: 'leave',
      swatch: (
        <span className={`${SWATCH} tw-bg-sky-500/15 tw-text-sky-700 dark:tw-text-sky-300`}>
          <LuTreePalm className="tw-h-2 tw-w-2" />
        </span>
      ),
    },
  ];

  return (
    <ul
      aria-label={label('title')}
      className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-2 tw-border-t tw-border-slate-200/80 tw-pt-3 tw-text-xs tw-text-slate-600 dark:tw-border-white/10 dark:tw-text-slate-300"
    >
      {items.map((item) => (
        <li key={item.key} className="tw-flex tw-items-center tw-gap-1.5">
          <span aria-hidden="true" className="tw-contents">{item.swatch}</span>
          {label(item.key)}
        </li>
      ))}
    </ul>
  );
};

export default LegendStrip;
